<!-- 
  管理分组列表
 -->

<template>
  <div class="group-list">
    <el-dialog title="分组管理" :visible.sync="dialogVisible"> 
      <div class="head">
        <div class="count">筛选分组总数：<strong>{{listData.length}}</strong></div>
        <el-button size="small" @click="addGroup">添加分组</el-button>
      </div>
      <h4 class="title">编辑分组</h4>
      <el-table
        :data="listData"
        :show-header="false"
        style="width: 100%">
        <el-table-column
          width="110">
          <template slot-scope="scope">
            <div class="item">
              <el-button
                size="mini"
                type="primary"
                @click="handleEdit(scope.row.id)">
                编辑
              </el-button>
              <el-button
                size="mini"
                @click="handleDelete(scope.row.id)"
                type="danger">
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          >
        </el-table-column>
        <el-table-column
          prop="address"
          width="60">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
    <edit-group v-if="editGroupShow" :formData="form" :id="id" :templateId="templateId" @closeDialog="closeModal" @refresh="getGroupList('refresh')"></edit-group>
  </div>
</template>

<script>
import * as api from 'src/api'
import { mapGetters } from 'vuex'
import { Message, MessageBox } from 'element-ui'
import * as common from 'src/config/common-config'
import editGroup from 'components/modal/customer/edit-group'

export default {
  created () {
    this.getGroupList()
  },
  data () {
    return {
      dialogVisible: false,
      editGroupShow: false,
      listData: [],
      // 编辑id
      id: '',
      // 编辑数据
      form: {
        name: '',
        data: [
          {
            index: '',
            name: '',
            symbol: '',
            data: ''
          }
        ]
      },
      moduleApi: common.moduleApi
    }
  },
  props: {
    templateId: {
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ])
  },
  methods: {
    // 获取分组列表
    getGroupList (type) {
      let url = `/listGroupApi/listAjax.html`
      let params = {
        refType: this.moduleApi[this.moduleName],
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        this.listData = data.result
        this.dialogVisible = true
        if (type === 'refresh') {
          this.$emit('refresh')
        }
      })
    },
    // 删除确认
    handleDelete (id) {
      MessageBox.confirm('确定删除该分组吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteItem(id)
      }).catch(() => {})
    },
    // 删除
    deleteItem (id) {
      let url = `/listGroupApi/delete.html`
      let params = {
        id: id,
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: '删除成功!'
        })
        this.getGroupList('refresh')
      })
    },
    // 编辑
    handleEdit (id) {
      let url = `/listGroupApi/edit.html`
      let params = {
        refType: this.moduleApi[this.moduleName],
        id: id,
        templateId: this.templateId
      }
      api.post(url, params, (data) => {
        this.form.name = data.name
        this.form.data = data.data
        this.id = id
        this.editGroupShow = true
        this.$emit('refresh')
      })
    },
    // 添加分组
    addGroup () {
      this.id = ''
      this.editGroupShow = true
    },
    // 监听子组件弹窗的关闭事件
    closeModal () {
      this.editGroupShow = false
      // 清空form 中的值
      this.form = {
        name: '',
        data: [
          {
            index: '',
            name: '',
            symbol: '',
            data: ''
          }
        ]
      }
    }
  },
  components: {
    editGroup
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .group-list {
    .el-dialog--small {
      width: 600px;
    }
    .head {
      position: relative;
      padding-bottom: 15px;
      .count {
        display: inline-block;
        line-height: 30px;
        strong {
          font-weight: bold;
        }
      }
      .el-button {
        position: absolute;
        right: 0;
      }
    }
    .title {
      line-height: 36px;
      padding-left: 12px;
      background-color: #dfe6ec;
      color: #000;
    }
  }
</style>


// WEBPACK FOOTER //
// group-list.vue?bf9052a6